import $ from 'jquery';
import modaal from 'modaal';
import * as CONST from '../../common/utils/constants';
import Util from '../../common/utils/ui';

class ModalNoLifeOnly {
    constructor() {
    }

    init() {
        this.bindEvents();
    }

	bindEvents() {
		if ($('#no-life-only-modal').length > 0) {
			$('.js-no-life-only-modal').modaal({
				content_source: '#no-life-only-modal',
				start_open: true,
				overlay_opacity: 0.6,
				custom_class: 'no-life-only-modal-wrapper',
                after_open: () => {
                        $('.modaal-close').focus();
                        $('.modaal-content-container').removeAttr('role');
                        $('.modaal-content.modaal-focus').attr('aria-modal', 'true');
                        $('.modaal-container').on('keydown', (e) => {
                            if ($(e.target).is('#QSIFeedbackButton-btn') && e.key === 'Tab' && !e.shiftKey) {
                                e.preventDefault();
                                $('.modaal-close').focus();
                            }
                            if ($(e.target).hasClass('modaal-close') && e.key === 'Tab' && !e.shiftKey) {
                                e.preventDefault();
                                $('#QSIFeedbackButton-btn').focus();
                            }
                             if ($(e.target).is('#QSIFeedbackButton-btn') && e.key === 'Tab' && e.shiftKey) {
                                e.preventDefault();
                                $('.modaal-close').focus();
                            }
                            if ($(e.target).hasClass('modaal-close') && e.key === 'Tab' && e.shiftKey) {
                                e.preventDefault();
                                $('#QSIFeedbackButton-btn').focus();
                            }
                        });
                }
			});
		}		
    }
}

export default ModalNoLifeOnly;

$(() => {
	const modalNoLifeOnly = new ModalNoLifeOnly();
	modalNoLifeOnly.init();
});